import { useSnapshot } from 'valtio';
import { browserState } from '../state';
import { BodyText, Modal } from '@servicetitan/design-system';
import styles from './MicrophoneAccessModal.module.css';

export default function MicrophoneAccessModal() {
  const state = useSnapshot(browserState);

  const handleClose = () => {
    browserState.showMicrophoneAccessModal = false;
  };

  return (
    <Modal
      open={state.showMicrophoneAccessModal}
      onClose={handleClose}
      title='Microphone Access Required'
    >
      <BodyText>
        To use voice features, please enable microphone access in your Chrome
        settings:
      </BodyText>

      <ol>
        <li>
          Navigate to{' '}
          <code className={styles.Url}>
            chrome://settings/content/microphone
          </code>
        </li>
        <li>Find this website in the list</li>
        <li>Change the setting from "Block" to "Allow"</li>
        <li>Reload the page after granting the permission</li>
      </ol>
    </Modal>
  );
}
